// Simple API client for user operations
// The actual business logic is in /backend_auth/services/userService.js
import { API_BASE_URL } from '../config';

const AUTH_API_BASE_URL = API_BASE_URL;

export const usersAPI = {
  /**
   * Get all users for the current user's organization
   */
  async getUsers(authToken) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/users`, { headers });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to fetch users';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Get user by ID
   */
  async getUserById(userId, authToken) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/users/${userId}`, { headers });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to fetch user';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Update user information
   */
  async updateUser(userId, updateData, authToken) {
    const headers = {
      'Content-Type': 'application/json',
    };
    
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/users/${userId}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to update user';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Remove user from organization
   */
  async removeUser(userId, authToken) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/users/${userId}`, {
      method: 'DELETE',
      headers
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to remove user';
      throw new Error(errorMessage);
    }

    return await response.json();
  },

  /**
   * Clean up invalid school access for users in the organization
   */
  async cleanupSchoolAccess(authToken) {
    const headers = {};
    if (authToken) {
      headers.Authorization = `Bearer ${authToken}`;
    }

    const response = await fetch(`${AUTH_API_BASE_URL}/api/users/cleanup-school-access`, { 
      method: 'POST',
      headers 
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const errorMessage = errorData.details || errorData.error || 'Failed to cleanup school access';
      throw new Error(errorMessage);
    }

    return await response.json();
  }
};

// Export as default for backward compatibility
export default usersAPI;
